<template>
  <v-card>
    <v-dialog v-model="$store.state.activeDialogOrders" persistent width="500px">
      <v-card height="250px" shaped class="rounded-card">
        <v-row style="max-width: 550px; height: 195px; margin: 0 auto;">
          <v-col id="base" md="12" style="height: 100%; position: relative; display: flex; flex-direction: column;">
            <v-row justify="center" class="pr-2 mt-4 pl-0 mb-3" style="text-align: center">
              <h4 v-if="orders.length>0" class="RestoRegular">Ayúdanos a evaluar <br>tus pedidos</h4>
              <h4 v-else class="RestoRegular">No hay ningún pedido <br>que evaluar</h4>
            </v-row>
            <v-row justify="center" align="start" style="overflow-y:scroll; overflow-x:hidden; height: 100px">
              <v-col class="mt-0 pt-0">
                <v-row v-for="(order, index) in orders" :key="index" justify="center" class="mb-2">
                  <v-btn @click="openDialog(order);" style="background-color: #E6E6E6; border-radius: 5px" class="buttonLower" >
                    <v-col align-self="center" style="font-size: 10px" class="RestRegular">
                      <v-row justify="center">
                        Tu pedido del día y hora:
                        {{order.fecha_alta}} 
                        <!-- Pedido:{{order.id_pedido}}  -->
                        <!-- Sucursal:{{order.id_sucursal}} -->
                      </v-row>
                    </v-col>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="close()">Salir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ##### DIALOGO EVALUAR #####  -->
    <v-dialog v-model="dialogEvaluate" persistent width="500px">
    <v-card shaped class="rounded-card">
      <v-row style="max-width: 600px; margin: 0 auto;">
        <v-col id="base" md="12" style="height: 100%; position: relative; display: flex; flex-direction: column;" class="mt-0 pt-0 pl-0 pr-0" >
          <v-row>
            <v-col class="ml-4 pt-0 pl-0 pr-0">
                <v-row justify="center" class="pr-5 pl-0">
                  <h2 class="RestoRegular">¡Ayúdanos a mejorar para tí!</h2>
                </v-row>  
              <!-- </v-col> -->
              <v-row justify="center" class="pt-3 pb-0 pr-5">
                <h4 style="color: #424242" class="RestoRegular">Califica tu pedido:</h4>
              </v-row>
                  <!-- ##### EVALUA TU PEDIDO ##### -->
                  <v-row justify="center" class="pt-3 pb-0 pr-4 pl-0">
                    <img class='icon' src="@/assets/Evalua_envio.png">
                  </v-row>
                  <v-row justify="center" class="pt-0 pr-3 pl-0">
                    <h4 style="color: #424242" class="RestoRegular">¿Qué te pareció tu envío?</h4>
                  </v-row>
                  <v-row justify="center" class="pt-0 pr-3 pl-0">
                    <v-rating
                      :color="$store.state.colors.primary"
                      v-model="rating"
                      background-color="grey darken-1"
                      hover
                      large
                    ></v-rating>
                  </v-row>
                  <!-- ##### EVALUA TU ENVÍO ##### -->
                  <v-row justify="center" class="pt-4 pb-0 pr-3 pl-0">
                    <img class='icon' src="@/assets/Evalua_comida.png">
                  </v-row>
                  <v-row justify="center"  class="pt-0 pr-3 pl-0">  
                    <h4 style="color: #424242" class="RestoRegular">¿Qué te pareció la comida?</h4>
                  </v-row>
                  <v-row justify="center" class="pt-0 pr-3 pl-0">
                      <v-rating
                        v-model="rating2"
                        :color="$store.state.colors.primary"
                        background-color="grey darken-1"
                        hover
                        large
                      ></v-rating>
                  </v-row>
                  <!-- ##### COMENTARIO ADICIONAL ##### -->
                  <!-- <v-row justify="center"  class="pt-5 pb-0 pr-4 pl-0">  
                    <h4 style="color: #424242" class="RestoRegular">¿Quieres agregar un comentario adicional?</h4>
                  </v-row>
                  <v-col width="50" class="pr-7 pt-0">
                    <v-row justify="center">
                        <v-textarea v-model="coment" outlined rows="3" hide-details="true"></v-textarea>
                    </v-row>
                  </v-col>   -->
                  <v-row justify="center" class="pt-6 pb-0 pr-3">
                    <v-btn @click="evaluateOrder()" width="210px" rounded :color="$store.state.colors.primary" dark large>Enviar</v-btn>
                  </v-row>  
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
  </v-card>  
</template>

<script>
import axios from 'axios';
export default {
  data()
  {
    return{
      orders: null,
      // validateLoad:true,
      dialogEvaluate: false,
      rating: 0,
      rating2: 0,
      coment: '', 
      temp: null
    }
  },
  created()
  {
    if(!this.$store.state.validationDelivery && this.$router.currentRoute.name != 'loginDeliveryMan')
    {
        this.$store.dispatch("GET", {url: 'notificaciones/' + localStorage.getItem("id_cliente"), headers: {Authorization: localStorage.getItem("token")}})
          .then(response => {
              console.log(`%cRESPONSE`, 'color: green; font-weight: bold;', response);
              this.orders = response.data;
              this.$store.state.notifications_amount = this.orders.length;
          })
          .catch(error => {
              console.log("Error: " + error);
          });
    }
  },
  methods:
  {
    close()
    {
      this.$store.state.activeDialogOrders = false
    },
    evaluateOrder()
    {

      var evaluateOrder =
      {
        id_pedido: this.temp,
        calif_pedido: this.rating2.toString(), 
        calif_entrega: this.rating.toString()
      }
      // console.log(evaluateOrder);
      axios.post('/encuesta', evaluateOrder, {headers: {Authorization: this.$store.state.token}})
          .then(response => {
            console.log(`%cRESPONSE`, 'color: green; font-weight: bold;', response);
            this.$store.dispatch("GET", {url: 'notificaciones/' + localStorage.getItem("id_cliente"), headers: {Authorization: localStorage.getItem("token")}})
              .then(response => {
                // console.log("OBTIENE NOTIFICACIONES")
                //   console.log(response)
                  this.orders = response.data;
                  this.$store.state.notifications_amount = this.orders.length;
              })
              .catch(error => {
                  console.log("Error: " + error);
              });
          this.dialogEvaluate = false
          })
          .catch(error => {
            // console.log(evaluateOrder)
              console.log(error);
          });
    }, 
    openDialog(orders)
    {
      this.temp = orders.id_pedido
      this.rating = 0, 
      this.rating2 = 0,
      this.dialogEvaluate = true
      // console.log("ORDERS", orders)
    }
  }
}
</script>

<style scoped>
.rounded-card
{
  border-radius: 10px;
}
</style>